import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { fetchAiDraftPreviewContent } from '@atlassian/jira-servicedesk-knowledge-performance/src/services/fetch-ai-draft-preview-content/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TEAM_NAME } from '@atlassian/jira-servicedesk-knowledge-performance/src/common/constants.tsx';
import {
	FETCH_AI_DRAFT_CONTENT,
	type FetchAIDraftContentAction,
} from '../../state/actions/fetch-ai-draft-content/index.tsx';
import { fetchAIDraftContentSuccess } from '../../state/actions/fetch-ai-draft-content-success/index.tsx';
import { fetchAIDraftContentFailure } from '../../state/actions/fetch-ai-draft-content-failure/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>) =>
	action$.ofType(FETCH_AI_DRAFT_CONTENT).mergeMap((action: FetchAIDraftContentAction) => {
		const { projectId, activationId, topicId, analyticsEvent } = action.payload;
		return Observable.fromPromise(fetchAiDraftPreviewContent(projectId, activationId, topicId))
			.map((aiDraftContentResp) => {
				fireTrackAnalytics(analyticsEvent, 'fetchAiDraftPreviewContent succeeded', {
					projectId,
					topicId,
				});
				return fetchAIDraftContentSuccess(aiDraftContentResp);
			})
			.catch((error) => {
				fireErrorAnalytics({
					meta: {
						id: 'fetchAiDraftPreviewContent',
						packageName: 'jiraServicedeskKnowledgeHub',
						teamName: TEAM_NAME,
					},
					error,
				});
				return Observable.of(
					fetchAIDraftContentFailure({
						topicId,
						error,
					}),
				);
			});
	});
